<template>
  <div>
    <div class="background-texture">
      <div class="client-logo logo-left" v-if="clientLogo">
        <img :src="clientLogo" :style="{height: logoheight ? logoheight + 'px' : '60px'}" alt=""/>
      </div>
      <div class="logo-elite" :class="{ 'logo-right': clientLogo, 'logo-left': !clientLogo }">
        <img src="../../assets/images/elitefit-ai-logo-white-bg.png" alt="EliteFit.AI Logo" @click="logout()"/>
      </div>
      <router-view/>
    </div>
  </div>
  </template>
  
  <script>
  import { createNamespacedHelpers } from "vuex";
  const { mapState, mapActions } = createNamespacedHelpers("campaign");
  
  export default {
    name: "CampaignLayout",
    data() {
      return {
        clientLogo: null,
        logoheight: null
      };
    },
    computed: {
      ...mapState(["campaign"]),
    },
    methods: {
      ...mapActions(["getCampaignDetails"]),
      async logout() {
        const result = confirm("If you want to logout?")
        if (result) {
          await this.$store.dispatch('logout', `/campaign/${this.$route.params.name}/sign-in`);
        }
      }
    },
    async mounted() {
      const details = await this.getCampaignDetails(this.$route.params.name);
      if (!details) {
        await this.$router.push({ name: "Not Found" });
      }
      if (details.config?.logo && details.config?.logo !== '') {
        this.clientLogo = details.config?.logo;
        this.logoheight = details.config?.height;
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .background-texture {
    background-image: url("../../assets/images/bg-fitsummit.png");
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    min-height: 100vh;
    position: relative;
  }
  .logo-right {
    right: 40px;
    top: 40px;
  }
  .logo-left {
    left: 40px;
    top: 40px;
  }
  .logo-elite {
    position: absolute;
    img {
      height: 100px;
    }
  }
  .client-logo {
    position: absolute;
    // img {
    //   height: 60px;
    // }
  }
  </style>
  